/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonApiLog,
    JsonApiLogFromJSON,
    JsonApiLogFromJSONTyped,
    JsonApiLogToJSON,
} from './JsonApiLog';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonAmmoLog
 */
export interface JsonAmmoLog {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonAmmoLog
     */
    allowedActions?: Array<JsonAmmoLogAllowedActionsEnum>;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    ammoAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    ammoAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    ammoLogId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    ammoLogType?: JsonAmmoLogAmmoLogTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    ammoType?: JsonAmmoLogAmmoTypeEnum;
    /**
     * 
     * @type {JsonApiLog}
     * @memberof JsonAmmoLog
     */
    apiLog?: JsonApiLog;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonAmmoLog
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    createdBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    eventId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    status?: JsonAmmoLogStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonAmmoLog
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonAmmoLog
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonAmmoLogAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonAmmoLogAmmoLogTypeEnum {
    Incoming = 'INCOMING',
    Outgoing = 'OUTGOING'
}/**
* @export
* @enum {string}
*/
export enum JsonAmmoLogAmmoTypeEnum {
    Bullet = 'BULLET'
}/**
* @export
* @enum {string}
*/
export enum JsonAmmoLogStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}

export function JsonAmmoLogFromJSON(json: any): JsonAmmoLog {
    return JsonAmmoLogFromJSONTyped(json, false);
}

export function JsonAmmoLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonAmmoLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'ammoAmount': !exists(json, 'ammoAmount') ? undefined : json['ammoAmount'],
        'ammoAt': !exists(json, 'ammoAt') ? undefined : json['ammoAt'],
        'ammoLogId': !exists(json, 'ammoLogId') ? undefined : json['ammoLogId'],
        'ammoLogType': !exists(json, 'ammoLogType') ? undefined : json['ammoLogType'],
        'ammoType': !exists(json, 'ammoType') ? undefined : json['ammoType'],
        'apiLog': !exists(json, 'apiLog') ? undefined : JsonApiLogFromJSON(json['apiLog']),
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'eventId': !exists(json, 'eventId') ? undefined : json['eventId'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonAmmoLogToJSON(value?: JsonAmmoLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'ammoAmount': value.ammoAmount,
        'ammoAt': value.ammoAt,
        'ammoLogId': value.ammoLogId,
        'ammoLogType': value.ammoLogType,
        'ammoType': value.ammoType,
        'apiLog': JsonApiLogToJSON(value.apiLog),
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'eventId': value.eventId,
        'partyId': value.partyId,
        'status': value.status,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

